import Vue from 'vue';
import OS from 'framework/utils/OS';

import style from "./css/PuzzleDate.module.css";
import { Provider } from "../types";

Vue.component('puzzle-date', {
  props: {
    date: String,
  },
  inject: [ Provider.LOCALIZATION ],
  render() {
    const dateElements = this.localization.getDate(this.date);
    return (
      <div class={OS.desktop ? style.content : style.content_mobile}>
        <div class={style.firstLine}>
          { dateElements.weekdayName }
        </div>
        <div class={style.secondLine}>
          { dateElements.complete }
        </div>
      </div>
    );
  },
});
